import React, { useEffect, useState } from "react";
import dlt from "../../Assets/Icons/trash.png";
import Transaction from "../../../API/API_SERVISES/Transaction";
// import MyContext from "./MyContext";

const MyPrescription = () => {

    const data = [
        { id: 1, eye: 'SPHERICAL', rightEye: '-3.50', leftEye: '-4.00' },
        { id: 2, eye: 'CYLINDRICAL', rightEye: '-0.75', leftEye: '-1.25' },
        { id: 3, eye: 'AXIS', rightEye: '150', leftEye: '130' },
        { id: 4, eye: 'AP', rightEye: '-', leftEye: '-' },
    ];

    const [lensData, setLensData] = useState();

    useEffect(() => {
        const fetchData = async () => {
            var loginDataString = localStorage.getItem("accountLogin");
            var loginData = JSON.parse(loginDataString);
            const data = await Transaction.getSaleLensDataByTransId(0, loginData.d2Id);
            setLensData(data);
        }
        fetchData();
    }, [])

    return (
        <div>
            <div className="Prescription-heading">
                <div className="saved-prescription">MY SAVED PRESCRIPTION</div>
                <div className="flex-prescripton">
                    <div className="left-prescription-width">
                        <div className="flex-power-type">
                            <p className="prescription-name-user">NAME : </p>
                            <p className="prescription-name-user">LENS2CART USER</p>
                        </div>
                        <div className="flex-power-type">
                            <p className="prescription-name-user">POWER TYPE : </p>
                            <p className="prescription-name-user">LENS</p>
                        </div>
                        <div className="date-create-type">
                            <p>Created Wed Jun 19 2024</p>
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead className="header-prescription-eye">
                                <tr>
                                    <th className="header-left-right-eye">EYE</th>
                                    <th className="header-left-right-eye">RIGHT EYE</th>
                                    <th className="header-left-right-eye">LEFT EYE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(row => (
                                    <tr key={row.id}>
                                        <td className="table-left-right-data">{row.eye}</td>
                                        <td className="table-prescription-data">{row.rightEye}</td>
                                        <td className="table-prescription-data">{row.leftEye}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* ********************************************* */}
                    <div className="right-prescription-width">
                        <div className="flex-power-type">
                            <p className="prescription-name-user">NAME : </p>
                            <p className="prescription-name-user">LENS2CART USER</p>
                        </div>
                        <div className="flex-power-type">
                            <p className="prescription-name-user">POWER TYPE : </p>
                            <p className="prescription-name-user">LENS</p>
                        </div>
                        <div className="date-create-type">
                            <p>Created Wed Jun 19 2024</p>
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead className="header-prescription-eye">
                                <tr>
                                    <th className="header-left-right-eye">EYE</th>
                                    <th className="header-left-right-eye">RIGHT EYE</th>
                                    <th className="header-left-right-eye">LEFT EYE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(row => (
                                    <tr key={row.id}>
                                        <td className="table-left-right-data">{row.eye}</td>
                                        <td className="table-prescription-data">{row.rightEye}</td>
                                        <td className="table-prescription-data">{row.leftEye}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default MyPrescription;
